<template>
  <section :class="$style.root">
    <div :class="$style.content">
      <div :class="$style.top">
        <h2 :class="$style.heading">
          {{ title }}
        </h2>
      </div>

      <CoreImageComponent
        v-if="localizedData?.cover_image?.data?.attributes"
        :image="localizedData?.cover_image?.data?.attributes"
        :class="$style.image"
      />

      <a
        v-if="localizedData?.download?.data?.attributes?.url"
        :href="localizedData?.download?.data?.attributes?.url"
        target="_blank"
        :class="$style.link"
      >
        {{ $t('shared.download') }}
      </a>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  entry: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.entry))
})

const title = computed(() => i18nGetLocalizedTitle(localizedData.value))
</script>

<style module>
.root {
  composes: container--default from global;
  padding: 0 var(--unit--horizontal);
}

.content {
  composes: font-size-medium from global;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-top: var(--stroke--medium) solid var(--color--black);

  padding-top: calc(var(--unit--vertical) * 2 - (var(--lh) - var(--fs)));
  padding-bottom: calc(var(--unit--vertical) * 2);
}

.root[data-last-child] .content {
  border-bottom: var(--stroke--medium) solid var(--color--black);
}

.top {
  display: flex;
  justify-content: center;
  align-items: baseline;

  margin-bottom: calc(var(--unit--vertical) * 1 - (var(--lh) - var(--fs)));
}

.image {
  width: 100%;
}

.heading {
  composes: reset-heading from global;
  text-align: center;
  text-transform: uppercase;
}

.link {
  composes: reset-link link-box from global;

  display: inline-block;
  margin-top: var(--unit--vertical);
}
</style>
